import { render, staticRenderFns } from "./RoleDrawer.vue?vue&type=template&id=183b10b2"
import script from "./RoleDrawer.vue?vue&type=script&lang=js"
export * from "./RoleDrawer.vue?vue&type=script&lang=js"
import style0 from "./RoleDrawer.vue?vue&type=style&index=0&id=183b10b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports